import { Component } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, serviceTypeId } from "../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import { insertUpdateDayWiseProgram_action, getDayWiseProgramDetails_action } from "../../actions/admin_module_action/master_action/dayWiseProgram_action";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";

import TimePicker from "react-time-picker";
import VisitorHeader2 from "../../common_components/visitor_module_header2";
import DelegateDrawer from "../../common_components/delegate_module_drawer";
import DelegateTopMenu from "../../common_components/delegate_module_topmenu";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";


class DayWiseProgram extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [{
                id: 1,
                Date: null,
                StartTime: null,
                EndTime: null,
                Title: null,
                Description: null,
                Speaker: null,
                Location: null,
            }],
            RoleID: JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID
        }
    }

    componentDidMount() {
        this.getDayWiseProgramDetails()
    }

    getDayWiseProgramDetails() {
        this.setState({ isLoading: true })
        this.props.getDayWiseProgramDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    const res = data.data
                    if (res.length > 0) {
                        const map = res.map((item, i) => {
                            return {
                                id: i + 1,
                                Date: new Date(item.Date),
                                StartTime: item.StartTime ? moment.utc(item.StartTime).format('HH:mm') : null,
                                EndTime: item.EndTime ? moment.utc(item.EndTime).format('HH:mm') : null,
                                Title: item.Title,
                                Description: item.Description,
                                Speaker: item.Speaker,
                                Location: item.Location,
                            }
                        })
                        this.setState({ list: map })
                    }
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onAddRow() {
        const { list } = this.state
        const isInvalid = list.some(item =>
            !item.Date ||
            !item.StartTime ||
            !item.Title?.trim() ||
            !item.Description?.trim() ||
            !item.Location?.trim()
        )

        if (isInvalid) {
            toastError("Please fill all mandatory fields")
            return
        }

        const id = list.length + 1
        const map = {
            id: id,
            Date: null,
            StartTime: null,
            EndTime: null,
            Title: null,
            Description: null,
            Speaker: null,
            Location: null,
        }
        list.push(map)
        this.setState({ list: list, })
    }


    insertUpdateDayWiseProgram() {
        const { list } = this.state

        const isInvalid = list.some(item =>
            !item.Date ||
            !item.StartTime ||
            !item.Title?.trim() ||
            !item.Description?.trim() ||
            !item.Location?.trim()
        )

        if (isInvalid) {
            toastError("Please fill all mandatory fields")
            return
        }

        this.setState({ isLoading: true })
        const array = []
        list.forEach(item => {
            const map = {
                DayWiseProgramID: 0,
                Date: item.Date != null ? moment(item.Date).format('YYYY-MM-DD') : '',
                StartTime: item.StartTime,
                EndTime: item.EndTime,
                Title: item.Title,
                Description: item.Description,
                Speaker: item.Speaker,
                Location: item.Location,
            }
            array.push(map)
        })
        this.props.insertUpdateDayWiseProgram_action(array)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    this.getDayWiseProgramDetails()
                    toastSuccess("Day wise program added successfully")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(id) {
        this.setState(prev => {
            const updatedlist = prev.list.filter(item => item.id !== id)
            return {
                list: updatedlist
            };
        }, () => {
            if (this.state.list.length == 0) {
                this.onAddRow();
            }
        });
    }

    handleInputChange = (value, index, field) => {
        const list = [...this.state.list];
        if (field === "Date") {
            list[index][field] = value;
        } else {
            list[index][field] = value.target.value;
        }
        this.setState({ list });
    };

    render() {
        const { isLoading, mainList, list, SDList, MainServiceID, IsActive, RoleID } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {
                    RoleID == 1 ? <ExhibitorHeader /> :
                        RoleID == 15 || RoleID == 3 ? <VisitorHeader2 /> :
                            <HeaderWithLogo />
                }
                <div
                    //  className="with-dr-container com-height"
                    className={RoleID == 1 ? "with-dr-container" : "with-dr-container mt-3"}
                >
                    <div className="main-container">
                        {
                            RoleID == 1 ? <ExhibitorDrawer /> :
                                RoleID == 15 ? <DelegateDrawer /> :
                                    RoleID == 3 ? <VisitorDrawer /> :
                                        <AdminDrawer />
                        }
                        {
                            RoleID == 1 ? <ExhibitorTopMenu /> :
                                RoleID == 15 ? <DelegateTopMenu /> :
                                    RoleID == 3 ? <VisitorTopMenu /> :
                                        null
                        }
                    </div>
                    <div className={RoleID != 15 && RoleID != 3 ? "mt-4" : ""}>
                        <div className={RoleID != 15 && RoleID != 3 ? "admin-top-space p-2" : ""}>
                            <div className="event-dashboard">

                                {list.map((item, index) => (
                                    <div className="modern-event-card">

                                        {/* Left Time Panel */}
                                        <div className="modern-time-panel">

                                            <div className="modern-date">
                                                {item.Date ? moment(item.Date).format('dddd, Do MMMM, YYYY') : '-'}
                                            </div>

                                            <div className="modern-time">
                                                {item.StartTime}

                                                {item.EndTime && (
                                                    <span> - {item.EndTime}</span>
                                                )}
                                            </div>

                                        </div>

                                        {/* Right Content */}
                                        <div className="modern-content">

                                            <div className="modern-top">

                                                <h4>
                                                    {item.Title}
                                                </h4>

                                                <div className="modern-badge">
                                                    Event
                                                </div>

                                            </div>

                                            <p>
                                                {item.Description}
                                            </p>

                                            <div className="modern-footer">
                                                {item.Speaker &&
                                                    <div className="modern-info">
                                                        <i className="bi bi-mic"></i>
                                                        {item.Speaker}
                                                    </div>
                                                }
                                                <div className="modern-info">
                                                    <i className="fa fa-map-marker"></i>
                                                    {item.Location}
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>
                    </div >
                </div >
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateDayWiseProgram_action, getDayWiseProgramDetails_action })(DayWiseProgram));